export default __webpack_public_path__ + "static/media/logo-md-1440w.753be6ed.webp";